import {
  Grid,
  Stack,
  TextField,
  Typography,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  Box,
} from "@mui/material";
import { useApp } from "../../../../hooks/useApp";
import Autocomplete from "@mui/material/Autocomplete";
import AssetCard from "../../../../components/Assetcard";

export default function FactoryExample({ asset, setAsset }) {
  const { vtecAssetsUnsorted } = useApp();
  const allAssets = vtecAssetsUnsorted || [];

  const handleFactoryChange = (newValue) => {
    setAsset((prevAsset) => ({ ...prevAsset, exampleflow: newValue?.id || "" }));
  };
  const handleRadioButtonChange = (event) => {
    setAsset((prevAsset) => {
      const updatedAsset = {
        ...prevAsset,
        library: {
          buttonType: event.target.value,
          customButtonText: "",
          customButtonUrl: "",
        },
      };
      if (prevAsset?.showLibrary) {
        const { showLibrary, ...restOfAsset } = updatedAsset; // Remove 'showLibrary' from the updatedAsset
        return {
          ...restOfAsset,
          library: updatedAsset.library,
        };
      }

      return updatedAsset;
    });
  };

  const getFactoryOptions = () =>
    allAssets.filter((ex) => ex.Title && (ex.Type === "factory" || ex.Type === "megafactory"));
  const getSelectedFactory = () =>
    allAssets.find((ex) => ex.id === asset.exampleflow) || null;

  return (
    <Grid container sx={{ flexDirection: "row", gap: 4 }}>
      <Grid
        item
        sx={{
          justifyContent: "center",
          alignItems: "center",
          width: "fit-content",
        }}
        xs={12}
        md={5}
      >
        <AssetCard asset={asset} />
      </Grid>
      <Grid item xs>
        <Stack direction="column" gap={1} sx={{ height: "100%" }}>
          <Typography fontWeight="bold">Bottom Button</Typography>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={asset.library?.buttonType || ""}
              onChange={handleRadioButtonChange}
            >
              <FormControlLabel
                value="noButton"
                control={<Radio />}
                label="No Button"
              />
              <FormControlLabel
                value="library"
                control={<Radio />}
                label="Library Button"
              />
              <FormControlLabel
                value="custom"
                control={<Radio />}
                label="Custom Button"
              />
            </RadioGroup>
          </FormControl>
          {asset.library?.buttonType === "custom" && (
            <Box>
              <TextField
                id="customButtonText"
                label="Custom Button Text"
                fullWidth
                size="small"
                value={asset.library?.customButtonText}
                sx={{
                  marginBottom: "8px",
                }}
                onChange={(e) => {
                  setAsset((prevAsset) => ({
                    ...prevAsset,
                    library: {
                      ...prevAsset.library,
                      customButtonText: e.target.value,
                    },
                  }));
                }}
              />
              <TextField
                id="customButtonUrl"
                label="Custom Button Url"
                fullWidth
                size="small"
                value={asset.library?.customButtonUrl}
                onChange={(e) => {
                  setAsset((prevAsset) => ({
                    ...prevAsset,
                    library: {
                      ...prevAsset.library,
                      customButtonUrl: e.target.value,
                    },
                  }));
                }}
              />
            </Box>
          )}
          <Typography fontWeight="bold">Factory Example</Typography>
          <Autocomplete
            disablePortal
            id="exampleSelect"
            options={getFactoryOptions()}
            getOptionLabel={(option) => option.Title || ""}
            isOptionEqualToValue={(option, value) =>
              option.id === value?.id
            }
            sx={{ width: "100%" }}
            size="small"
            value={getSelectedFactory()}
            onChange={(event, newValue) => handleFactoryChange(newValue)}
            renderOption={(props, option) => (
              <li {...props} key={option.id || option.Title}>
                {option.Title || ""}
              </li>
            )}
            renderInput={(params) => <TextField {...params} label="Example" />}
          />
          <TextField
            id="examplecolor"
            label="Example Color"
            fullWidth
            value={asset.exampleColor}
            size="small"
            onChange={(e) => {
              setAsset((prevAsset) => ({
                ...prevAsset,
                exampleColor: e.target.value,
              }));
            }}
          />
          <TextField
            id="exampletext1"
            label="Example Header"
            fullWidth
            value={asset.exampleHeader}
            size="small"
            onChange={(e) => {
              setAsset((prevAsset) => ({
                ...prevAsset,
                exampleHeader: e.target.value,
              }));
            }}
          />
          <TextField
            id="exampletext2"
            label="Example Text"
            fullWidth
            value={asset.exampleText}
            size="small"
            onChange={(e) => {
              setAsset((prevAsset) => ({
                ...prevAsset,
                exampleText: e.target.value,
              }));
            }}
          />
          <Typography fontWeight="bold">Toggle Button Text</Typography>
          <TextField
            id="toggleButtontext"
            label="Button Text"
            fullWidth
            size="small"
            value={asset?.toggleButtonText}
            sx={{
              marginBottom: "8px",
            }}
            onChange={(e) => {
              setAsset((prevAsset) => ({
                ...prevAsset,
                toggleButtonText: e.target.value,
              }));
            }}
          />
        </Stack>
      </Grid>
    </Grid>
  );
}
